module.exports = __webpack_public_path__ + "static/media/canary.9ba6b9b5.svg";